import CheckCircleIcon from 'assets/icons/check_circle.svg';
import React from 'react';

import { Box, Grid, Stack, Typography } from '@mui/material';

export const TutorPlanOrderResumeSuccess: React.FC = () => {
  return (
    <Grid item container xs={12} lg={12} spacing={2} justifyContent="center">
      <Grid item xs={12} md={6} spacing={2}>
        <Stack spacing={2} alignContent="center" alignItems="center">
          <Box
            component="img"
            alt="Ícone sucesso"
            src={CheckCircleIcon}
            width={70}
            height={70}
          />

          <Typography color="#7A8388" fontSize={20} fontWeight={400}>
            Pronto, seu pagamento foi aprovado!
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  );
};
